import { css } from "@emotion/css";

export const createButtonLinkStyles = () => {
  return {
    root: css({
      textDecoration: "none",
      textAlign: "center",
      lineHeight: "normal",
    }),
  };
};
